export default () => ({
  loading: [],
  valerrors: {},
  flashBanner: null,
  deleteModal: false
});
